import { useRouter } from 'next/router';
import { query as urlQuery } from 'urlcat';

export type UsePaginationFn = ReturnType<typeof usePagination>;

export function usePagination(
  page: number,
  pageCount: number,
  url?: string,
  withoutQuery?: boolean,
  setPage?: (value: number) => void
) {
  const router = useRouter();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const setUrlPage = (url: string, page: number, withoutQuery?: boolean) => {
    if (withoutQuery === true) {
      router?.push(
        `${url}&${urlQuery({
          page: page,
        })}`,
        undefined,
        { shallow: true }
      );
    } else {
      router?.push(
        `${url}?${urlQuery({
          ...router.query,
          page: page,
        })}`,
        undefined,
        { shallow: true }
      );
    }
  };

  const nextPage = () => {
    if (url) {
      setUrlPage(url, page + 1, Boolean(withoutQuery));
    }
    if (page < pageCount && setPage) {
      setPage(page + 1);
    }
    setTimeout(scrollToTop, 200);
  };

  const previousPage = () => {
    if (url) {
      setUrlPage(url, page - 1, Boolean(withoutQuery));
    }
    if (page >= 1 && setPage) {
      setPage(page - 1);
    }
    setTimeout(scrollToTop, 200);
  };

  const lastPage = () => {
    if (url) {
      setUrlPage(url, pageCount, Boolean(withoutQuery));
    }
    if (setPage) {
      setPage(pageCount);
    }
    setTimeout(scrollToTop, 200);
  };

  const firstPage = () => {
    if (url) {
      setUrlPage(url, 1, Boolean(withoutQuery));
    }
    if (setPage) {
      setPage(1);
    }
    setTimeout(scrollToTop, 200);
  };

  return { nextPage, previousPage, lastPage, firstPage, setUrlPage };
}
